export default "__VITE_ASSET__5Gp0bA7a__"